import {
  createImage,
  CreateImageInput,
  CreateImageMutation,
  graphqlCall,
} from '@akin-home/amplify';

export const createImageMutation = async (
  input: CreateImageInput
): Promise<CreateImageMutation> =>
  (await graphqlCall(createImage, { input })).data;
